module.exports = __webpack_public_path__ + "static/media/interaction.e92e713e.png";